import { store } from '../reduxToolkit/store'
import { Provider } from 'react-redux'
import React from 'react'

export function ReduxToolkitProvider({children}: React.PropsWithChildren) {
  return <Provider store={store}>
    {children}
  </Provider>
}